import PostView from './PostView'

export default PostView
